import React, { useState } from "react";

const FilterSidebar = ({ onApplyFilters, onClearFilters }) => {
  // Add props
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRating, setSelectedRating] = useState(null);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [sortOption, setSortOption] = useState("default");

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    console.log("Sidebar toggled. IsOpen:", !isOpen);
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating);
    console.log("Rating selected:", rating);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    console.log("Sort option selected:", e.target.value);
  };

  const applyFilters = (e) => {
    e.preventDefault();

    console.log("Filters applied with the following options:");
    console.log({
      rating: selectedRating,
      minPrice: minPrice || "",
      maxPrice: maxPrice || "",
      sortOption,
    });

    onApplyFilters({
      rating: selectedRating,
      minPrice: minPrice || "",
      maxPrice: maxPrice || "",
      sortOption,
    });

    toggleSidebar();
  };

  const clearFilters = () => {
    setSelectedRating(null);
    setMinPrice("");
    setMaxPrice("");
    setSortOption("default");
    console.log("Filters cleared.");
    onClearFilters();
  };

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-full shadow hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition-transform transform hover:scale-105 flex items-center space-x-2"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16m-7 6h7"
          />
        </svg>
        <span>{isOpen ? "Close Filters" : "Filter"}</span>
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black opacity-50"
          onClick={toggleSidebar}
        />
      )}

      <div
        className={`fixed top-0 right-0 z-50 w-80 h-full bg-white shadow-md dark:bg-gray-800 transition-transform transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">
            Filters
          </h3>
          <button
            onClick={toggleSidebar}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <form onSubmit={applyFilters} className="p-4">
          <div className="mb-6">
            <h4 className="mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Sort By
            </h4>
            <select
              value={sortOption}
              onChange={handleSortChange}
              className="w-full p-2 border border-gray-300 rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="default">Default</option>
              <option value="price-asc">Price: Low to High</option>
              <option value="price-desc">Price: High to Low</option>
              <option value="discount">Discount</option>{" "}
            </select>
          </div>
          <div className="mb-6">
            <h4 className="mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Price Range
            </h4>
            <label className="block text-gray-700 dark:text-gray-300">
              Min Price
            </label>
            <input
              type="number"
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded mt-1 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="Min"
            />
            <label className="block mt-4 text-gray-700 dark:text-gray-300">
              Max Price
            </label>
            <input
              type="number"
              value={maxPrice}
              onChange={(e) => setMaxPrice(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded mt-1 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="Max"
            />
          </div>

          <div className="mb-6">
            <h4 className="mb-2 text-sm font-medium text-gray-900 dark:text-white">
              Rating
            </h4>
            <ul className="space-y-2">
              {[5, 4, 3, 2, 1].map((rating) => (
                <li key={rating} className="flex items-center">
                  <input
                    id={`star-${rating}`}
                    type="radio"
                    name="rating"
                    value={rating}
                    checked={selectedRating === rating}
                    onChange={() => handleRatingChange(rating)}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor={`star-${rating}`}
                    className="flex items-center ml-2 cursor-pointer"
                  >
                    <div className="flex">
                      {Array.from({ length: 5 }, (_, index) => (
                        <svg
                          key={index}
                          aria-hidden="true"
                          className={`w-5 h-5 ${
                            index < rating
                              ? "text-yellow-400" 
                              : "text-gray-400 dark:text-gray-500"
                          }`}
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M9.049 2.927a1 1 0 011.902 0l1.07 3.292a1 1 0 00.95.69h3.462a1 1 0 01.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292a1 1 0 01-1.54 1.118L10 13.012l-2.8 2.034a1 1 0 01-1.54-1.118l1.07-3.292a1 1 0 00-.364-1.118L3.566 8.72a1 1 0 01.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                  </label>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex space-x-4">
            <button
              type="submit"
              className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
            >
              Apply Filters
            </button>
            <button
              type="button"
              onClick={clearFilters}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-red rounded-md hover:bg-gray-300 dark:bg-red-600 dark:text-white dark:hover:bg-gray-700"
            >
              Clear All
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default FilterSidebar;
